module.exports = __webpack_public_path__ + "img/404.5d52ef5f.png";